import { type FC } from 'react';
import {
  Copy
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconCopyProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconCopy: FC<UiIconCopyProps> = (props) => {
  return (
    <UiIcon
      IconComponent={Copy}
      {...props}
    />
  );
};
